import { useQuery } from '@tanstack/react-query';
import {getImageHistory} from '@/api/images';
import { queryKeys } from '@/lib/queryKeys';

export function useImageHistoryQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.images.history(),
    queryFn: () => getImageHistory(),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}